import { EGarageMaterial } from '../../../../json_query';
import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IGarageMaterialsTagType = 'advanced-garageMaterial';

export interface IGarageMaterialsTag {
  type: 'advanced-garageMaterial';
  value: EGarageMaterial;
}

export const isGarageMaterialsTag = (tag: TTag): tag is IGarageMaterialsTag => tag.type === IGarageMaterialsTagType;

export const garageMaterialsTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.garage_material && jsonQuery.garage_material.value;

    let nextTags = tags.filter(
      tag => tag.type !== IGarageMaterialsTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: EGarageMaterial) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is IGarageMaterialsTag => isGarageMaterialsTag(tag) && tag.value === value,
            () => ({ type: IGarageMaterialsTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
